<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/dashboard/" id="accountOwnerHome">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/myAccountList" [queryParams]="{ tab: 'manageSellers'}"
                                     id="contacts">My Account</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Seller</li>
    </ol>
  </nav>
  <form>
    <div class="row mt-3">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Details</h2>
          <div class="row mt-3">
            <div class="col-md-12 col-md-8">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group ">
                    <label class="control-label" for="companyName">Company Name</label>
                    <input type="text" id="companyName" [(ngModel)]="companyName" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           [ngClass]="{'is-invalid':statusText1}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off">
                  </div>
                </div>

                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="firstName">First Name</label>
                    <input type="text" id="firstName" [(ngModel)]="firstName" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           (blur)="typeFirstName()" [ngClass]="{'is-invalid':statusText1}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="lastName">Last Name</label>
                    <input type="text" id="lastName" [(ngModel)]="lastName" [ngModelOptions]="{standalone: true}"
                           class="form-control"
                           (blur)="typeLastName()" [ngClass]="{'is-invalid':statusText2}"
                           onkeypress="return event.charCode >= 65 && event.charCode <= 90 || event.charCode >= 97 && event.charCode <= 122 || event.charCode == 32"
                           autocomplete="off" required>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="contactNumber">Phone Number</label>
                    <input type="text" id="contactNumber"
                           onkeypress='return event.charCode >= 48 && event.charCode <= 57' [(ngModel)]="mobileNumber"
                           [ngModelOptions]="{standalone: true}" (blur)="validateMobile()"
                           [ngClass]="{'is-invalid':statusText3}" maxlength="10" class="form-control" required>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Email</label>
                    <input type="text" id="email" [(ngModel)]="email" [ngModelOptions]="{standalone: true}"
                           (blur)="validateEmail()" [ngClass]="{'is-invalid':statusText4}" class="form-control"
                           required>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Seller ID</label>
                    <input type="text" id="sellerId" [(ngModel)]="sellerCode" [ngModelOptions]="{standalone: true}"
                           (blur)="validateSellerCode()" [ngClass]="{'is-invalid':statusText9}" class="form-control"
                           required>
                  </div>
                </div>
                <div class="col-md-3 required">
                  <div class="form-group ">
                    <label class="control-label" for="email">Password</label>
                    <input type="password" id="password" [(ngModel)]="password" [ngModelOptions]="{standalone: true}"
                           (blur)="validatePassword()" [ngClass]="{'is-invalid':statusText10}" class="form-control"
                           required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12 mb-1 text-danger fw-500"
           *ngIf="statusText4 || statusText3 || statusText1 || statusText2 || statusText5 || statusText6 || statusText7 || statusText8  || statusText9  || statusText10 ">
        Please Enter Mandatory Fields
      </div>

      <div class="col">
        <div class="inner-box">
          <div>
            <h2 class="text-black mb-3">Address</h2>
            <div class="row">
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="address1">Address 1</label>
                  <input type="text" id="address1" [(ngModel)]="address1" class="form-control"
                         (blur)="createAddress()" [ngClass]="{'is-invalid':statusText5}"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="address2">Address 2</label>
                  <input type="text" id="address2" [(ngModel)]="address2" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label">City</label>
                  <ng-select type="text" id="city" [(ngModel)]="city"
                             [ngModelOptions]="{standalone: true}" [items]="citiesList" placeholder="City"
                             (blur)="createCity()" [ngClass]="{'is-invalid':statusText6}" required>
                  </ng-select>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label">State</label>
                  <ng-select id="State" [(ngModel)]="state" [ngModelOptions]="{standalone: true}"
                             [ngClass]="{'service-error':statusText7}"
                             (blur)="createState()"
                             [ngClass]="{'is-invalid':statusText7}"
                             [items]="statesList"
                             placeholder="State">
                  </ng-select>
                </div>
              </div>
              <div class="col-md-3 required">
                <div class="form-group ">
                  <label class="control-label" for="accountZipAlt">Zip</label>
                  <input type="text" id="accountZipAlt" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                         maxlength="6" [(ngModel)]="zip" class="form-control" (change)="changeCityAndState()" placeholder="Enter PinCode"
                         (blur)="createZip()" [ngClass]="{'is-invalid':statusText8}"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<div class="form-btn-section">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/myAccountList" [queryParams]="{ tab: 'manageSellers'}"
              class="btn btn-cancel" id="cancel">Cancel
      </button>
      <button type="submit" class="btn btn-orange ml-2"
              id="save" (click)="createSeller()">Save
      </button>
    </div>
  </div>
</div>
